import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function countriesReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_UPDATE_COUNTRIES:
    return {
      ...state,
      data: action.payload,
    };
    default:
      return state;
  }
}
 
export default countriesReducer;
